import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/channels/guest/$channelId/thread/$threadId` activates the
// reply-thread column (col 3). The Channels LAYOUT route (channels.tsx) reads
// `$threadId` off the leaf match and renders the ThreadPanel via ColumnLayout.
export const Route = createFileRoute(
  "/$orgSlug/$eventSlug/channels/guest/$channelId/thread/$threadId",
)({
  component: () => null,
})
